import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'fcp-new-banner-main',
  templateUrl: './new-banner-main.component.html',
  styleUrls: ['./new-banner-main.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NewBannerMainComponent implements OnInit {
  @Input() public banner: any;
  @Output() public wasClicked: EventEmitter<any> = new EventEmitter();

  public isDeviceDesktop: boolean;

  constructor() {
    this.checkDevice();
  }
  
  ngOnInit() {}

  private checkDevice() {
    if (window.innerWidth < 769) {
      this.isDeviceDesktop = false;
      return;
    }
    this.isDeviceDesktop = true;
  }

  public checkClick(button): void {
    this.wasClicked.emit(button);
  }
}
